<div [formGroup]="formGroup">
	<div class="form-group">
		<div class="row">

			<!-- Street -->
			<div
				aeGroupValidation
				class="form-group"
				[ngClass]="{
					'col-md-8': shortenRows,
					'col-md-12': !shortenRows,
					'mb-1': reduceSpacing,
				}"
			>
				<ae-form-label
					for="address.form.street"
					label="Street"
					[ngClass]="{ 'screen-reader-text': !showLabels }"
					[required]="requiredControls.street"
				/>
				<input
					aeInputTrim
					autocomplete="off"
					class="form-control"
					id="address.form.street"
					type="text"
					[formControl]="formGroup.controls.street"
					[placeholder]="!showLabels ? 'Street' : ''"
					[required]="requiredControls.street"
				/>
				<ae-group-validation-display [maxDisplay]="1">
					<ng-template aeValidationError="required">
						Street is required
					</ng-template>
				</ae-group-validation-display>
			</div>

			<!-- Street 2 -->
			<div
				aeGroupValidation
				class="form-group"
				[ngClass]="{
					'col-md-8': shortenRows,
					'col-md-12': !shortenRows,
					'mb-1': reduceSpacing,
				}"
			>
				<label
					for="address.form.street2"
					[ngClass]="{ 'screen-reader-text': !showLabels }"
					>Street 2</label
				>
				<input
					aeInputTrim
					autocomplete="off"
					class="form-control"
					id="address.form.street2"
					type="text"
					[formControl]="formGroup.controls.street2"
					[placeholder]="!showLabels ? 'Street 2' : ''"
				/>
			</div>

			<div [ngClass]="shortenRows ? 'col-md-8' : 'col-md-12'">
				<div class="row">

					<!-- City -->
					<div
						aeGroupValidation
						class="form-group"
						[ngClass]="{
							'col-lg-9': excludeZip,
							'col-md-6': !excludeZip,
							'pe-0': reduceSpacing,
						}"
					>
						<ae-form-label
							for="address.form.city"
							label="City"
							[ngClass]="{ 'screen-reader-text': !showLabels }"
							[required]="requiredControls.city"
						/>
						<input
							aeInputTrim
							autocomplete="off"
							class="form-control"
							id="address.form.city"
							type="text"
							[formControl]="formGroup.controls.city"
							[placeholder]="!showLabels ? 'City' : ''"
							[required]="requiredControls.city"
						/>
						<ae-group-validation-display [maxDisplay]="1">
							<ng-template aeValidationError="required">
								City is required
							</ng-template>
						</ae-group-validation-display>
					</div>

					<!-- State -->
					<div
						aeGroupValidation
						class="form-group col-md-3"
						[ngClass]="{
							'ps-0 pe-0': reduceSpacing,
						}"
					>
						<ae-form-label
							for="address.form.state"
							label="State"
							[ngClass]="{ 'screen-reader-text': !showLabels }"
							[required]="requiredControls.state"
						/>
						<ng-select
							bindLabel="key"
							bindValue="key"
							labelForId="address.form.state"
							[attr.aria-required]="requiredControls.state"
							[clearable]="false"
							[formControl]="formGroup.controls.state"
							[items]="stateOptions"
							[placeholder]="!showLabels ? 'ST' : ''"
						/>
						<ae-group-validation-display [maxDisplay]="1">
							<ng-template aeValidationError="required">
								State is required
							</ng-template>
						</ae-group-validation-display>
					</div>
					@if (!excludeZip) {

						<!-- Zip Code -->
						<div
							aeGroupValidation
							class="form-group col-md-3"
							[ngClass]="{
								'ps-0': reduceSpacing,
							}"
						>
							<ae-form-label
								for="address.form.zip"
								label="Zip Code"
								[ngClass]="{ 'screen-reader-text': !showLabels }"
								[required]="requiredControls.zip"
							/>
							<input
								aeInputTrim
								autocomplete="off"
								class="form-control"
								id="address.form.zip"
								type="text"
								[formControl]="formGroup.controls.zip"
								[placeholder]="!showLabels ? 'Zip Code' : ''"
								[required]="requiredControls.zip"
							/>
							<ae-group-validation-display [maxDisplay]="1">
								<ng-template aeValidationError="required">
									Zip Code is required
								</ng-template>
								<ng-template aeValidationError="pattern">
									Invalid Zipcode format
								</ng-template>
								<ng-template aeValidationError="zipcode" let-error>
									{{ error.requirements }}
								</ng-template>
							</ae-group-validation-display>
						</div>
					}
				</div>
			</div>
		</div>
	</div>
</div>
